import { render, staticRenderFns } from "./CarInformations.vue?vue&type=template&id=6c388b1a&scoped=true"
import script from "./CarInformations.vue?vue&type=script&lang=js"
export * from "./CarInformations.vue?vue&type=script&lang=js"
import style0 from "./CarInformations.vue?vue&type=style&index=0&id=6c388b1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c388b1a",
  null
  
)

export default component.exports